
delta.report = function () {
    var

        _$wrapper = null,

        _report_id = null,

        //set to true when a popup is open, can't open another
        _popup_open = false,

        //
        // init 
        //
        init = function () {
            _$wrapper = $('.layout-report');

            if (_$wrapper.length > 0) {
                _report_id = _$wrapper.find('#hdnReportID').val();

                setupReportSettingsLink();
                setupChangeDate();
                setupShowProblems();
                setupAddMenu();
                delta.reportFEColumnEdit.init(_report_id);
                // $.YPTC.Delta.Report.EditColumnMap.Init(_report_id);
                $.YPTC.Delta.Report.EditLine.Init(_report_id);
                $.YPTC.Delta.Report.EditColumnSubtotal.Init(_report_id);
                setupPopoverLines();
                showAddColumnPopup();
                showAddDimensionColumnsPopup();
                showEditColumnPopup();
                setupReportDimensionFilterLink();
                setupHideShowSpinner();
                setupReportDimensionFilter();
                setupColumnAddEditSection();
                setupForecastPopup();
                setupRollingForecastColumnSettings();

                //NARF
                showEditValuePopup();
                showRestrictionsPopup();
            }
        },

        //
        // setup the change date popup
        //
        setupChangeDate = function () {
            _$wrapper.on('click', '#lnkChangeDate', function () {
                if (!_popup_open) {
                    _popup_open = true;

                    delta.ajax.get('/report/changeDate',
                        function (html) {
                            delta.popup.open({
                                type: 'confirm',
                                title: 'Report Date',
                                content: html,
                                cssClass: 'change-date-popup',
                                afterOpen: function ($popup) {
                                    _popup_open = false;

                                    //setup date picker
                                    delta.utility.setupDatePicker($popup);
                                },
                                okCallback: function ($popup) {
                                    $('.change-date-popup .modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');

                                    var formData = new FormData();
                                    $popup.find('.modal-body').find('input').each(function () {
                                        var $elem = $(this);
                                        if ($elem.attr('type') == 'checkbox') {
                                            if ($elem.is(':checked')) {
                                                formData.append($elem.attr('name'), $elem.val());
                                            }
                                        } else {
                                            formData.append($elem.attr('name'), $elem.val());
                                        }
                                    });

                                    delta.ajax.postFormData('/report/changeDate',
                                        formData,
                                        function (result) {
                                            if (result.ok) {
                                                location.reload();
                                            } else {
                                                $('.change-date-popup .modal-footer .fa-spinner').remove();
                                                //invalid update popup
                                                $popup.find('.modal-body').html(result.html);

                                                //setup date picker
                                                delta.utility.setupDatePicker($popup);

                                                delta.popup.enableButtons($popup);
                                            }
                                        }
                                    );

                                    return false;
                                }
                            });
                        }
                    );
                }

                return false;
            });
        },

        //
        // setup the Show Problems link
        //
        setupShowProblems = function () {
            _$wrapper.on('click', '.lnk-problems', function () {
                if (!_popup_open) {
                    _popup_open = true;

                    delta.ajax.get(
                        '/report/showproblems?reportID=' + _report_id,
                        function (result) {
                            delta.popup.open({
                                type: 'alert',
                                title: 'Report Problems',
                                css: "modal-lg",
                                content: result,
                                afterOpen: function () {
                                    _popup_open = false;
                                }
                            });
                        }
                    );
                }

                return false;
            });
        },

        //
        // setup the add popup menu
        //
        setupAddMenu = function () {
            _$wrapper.on('click', '.lnk-add-menu', function () {
                $a = $(this);

                // Get the next sibling element
                var spinner = $a.next('.lnk-line-edit-spinner');

                //get the json definition for the items & build the items object
                var json = JSON.parse(this.dataset.menu);
                var items = {};
                for (var i = 0; i < json.length; i++) {
                    items[json[i].Value] = { name: json[i].Display };
                }

                //we're defining a new global context menu below, we must destroy any existing ones first.
                $.contextMenu('destroy', $a);

                //define the global context menu
                $.contextMenu({
                    selector: '.lnk-add-menu',
                    trigger: 'none',
                    determinePosition: function ($menu) {
                        $menu.css('display', 'block').position({ my: 'left top', at: 'left bottom', of: this })
                    },
                    items: items,
                    // In the callback function of the context menu
                    callback: function (key) {
                        var $tr = $(this).closest('tr');

                        var popupTitle = `Add ${items[key].name}`;
                        var reportLabel = $tr.find('.report-label').find('div').text();
                        var addSectionType = key;
                        var afterIndex = $tr.attr('data-line-index');
                        var defaultLabel = '';

                        // For Cash Flow specific section types
                        if (key == 'CF_InvestingActivities' || key == 'CF_FinancingActivities') {
                            // Create default label based on section type
                            defaultLabel = key == 'CF_InvestingActivities'
                                ? 'INVESTING ACTIVITIES'
                                : 'FINANCING ACTIVITIES';

                            $.YPTC.Delta.Report.EditLine.Show(
                                `Add ${items[key].name}`,
                                reportLabel,
                                null,
                                null,
                                addSectionType,
                                null,
                                afterIndex,
                                true,
                                defaultLabel
                            );

                            return;
                        }

                        // Standard flow for other options
                        if (key != 'Section' && key != 'Detail') {
                            defaultLabel = items[key].name;
                        }

                        //show spinner and hide the plus button
                        let spinner = $(this).next('.lnk-line-edit-spinner');
                        spinner.show();
                        $a.hide();

                        $.YPTC.Delta.Report.EditLine.Show(
                            popupTitle, reportLabel, null, null, addSectionType, null, afterIndex, true, defaultLabel
                        );
                    }
                });

                $a.contextMenu(); //create the context menu

                return false;
            });
        },


        setupReportSettingsLink = function () {
            $('#btnReportSettings').on('click', function () {
                if (!_popup_open) {
                    _popup_open = true;
                    delta.ajax.get(`/report/reportSettings?reportID=${_report_id}`,
                        function (result) {
                            delta.popup.open({
                                type: 'confirm',
                                title: 'Report Settings',
                                content: result,
                                css: 'report-settings',
                                afterOpen: function () {
                                    _popup_open = false;
                                    document.getElementById('SuppressZeroSections').addEventListener('click', function(){
                                        let cbxZeroLines = document.getElementById('SuppressZeroLines');
                                        if (this.checked) {
                                            cbxZeroLines.checked = true;
                                            cbxZeroLines.disabled = true;
                                        }
                                        else {
                                            cbxZeroLines.disabled = false;
                                        }
                                    })
                                },
                                okCallback: function ($popup) {
                                    var reportType = $popup.find('.modal-body').find('#ReportType').val();
                                    if (reportType == 'IncomeStatement') {
                                        var dimensionType = $popup.find('.modal-body').find('#DimensionType').val();
                                        var originalDimensionType = $popup.find('.modal-body').find('#OriginalDimensionType').val();

                                        //show prompt if dimension type changed
                                        if (dimensionType != originalDimensionType && originalDimensionType != 'None') {
                                            delta.popup.open({
                                                type: 'confirm',
                                                title: 'Dimension Changed',
                                                content: 'Altering the dimension type for this report will delete any dimension mappings that were previously configured.  Account mappings will be preserved.  Are you sure you want to change the dimension type?',
                                                css: 'modal-lg',
                                                okButtonText: 'Yes, Change Dimension',
                                                okCallback: function() {
                                                    saveReportSettings($popup);
                                                },
                                                cancelCallback: function() {
                                                    delta.popup.enableButtons($popup);
                                                }
                                            });
                                        } else {
                                            saveReportSettings($popup);
                                        }
                                    } else {
                                        saveReportSettings($popup);
                                    }


                                    return false;
                                },
                            });
                        }
                    );
                }
                return false;
            });
        },       


        saveReportSettings = function($popup) {
            var formData = new FormData();
            $('.report-settings .modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');
            $popup.find('.modal-body').find('input,select').each(function () {
                if (this.type == 'checkbox') {
                    if (this.checked) formData.append(this.name, true);
                }
                else {
                    formData.append(this.name, this.value);
                }
            });

            delta.ajax.postFormData('/report/reportsettings',
                formData,
                function (result2) {
                    if (result2.ok) location.reload();
                    else {
                        $('.report-settings .modal-footer .fa-spinner').remove();
                        delta.popup.enableButtons($popup);
                        alert('Problem encountered while attempting to save Report Settings!');
                    }
                }
            );
        },

        setupReportDimensionFilterLink = function () {
            _$wrapper.on('click', '#btnReportFilter', function () {
                if (!_popup_open) {
                    _popup_open = true;
                    delta.ajax.get(`/report/ReportDimensionFilter?reportID=${_report_id}`,
                        function (result) {
                            delta.popup.open({
                                type: 'confirm',
                                title: 'Report Dimension Filter',
                                content: result,
                                okButtonText: "Save",
                                cssClass: 'report-dimension-filter',
                                afterOpen: function () {
                                    _popup_open = false;
                                },
                                okCallback: function ($popup) {
                                    var formData = new FormData();
                                    $('.modal-body', $popup).animate({ scrollTop: 0 }, "fast");
                                    $('.report-dimension-filter .modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');

                                    // Get all the filters and add it to the formData
                                    $popup.find('.modal-body').find('input[name=filters]:checked').each(function(idx) {
                                        var $chk = $(this);
                                        
                                        formData.append(`Filters[${idx}].FilterType`, $chk.attr('data-filter-type'));
                                        formData.append(`Filters[${idx}].FilterID`, $chk.val());
                                    })

                                    formData.append('ReportID', parseInt(_$wrapper.find('#hdnReportID').val()));

                                    delta.ajax.postFormData('/report/ReportDimensionFilter',
                                        formData,
                                        function (result2) {
                                            location.reload();
                                        }
                                    );

                                    return false;
                                },
                            });
                        }
                    );
                }
            });
        },

        setupPopoverLines = function () {
            //  _$wrapper.find('.popover-lines').popover();
            _$wrapper.on('mouseover', '.popover-lines', function () {
                $(this).popover();
            });
        },

        setupHideShowSpinner = function myfunction() {
            $(document).on('shown.bs.modal', '.line-edit-popup', function () {
                //hide any spinner that we have created.
                $('.lnk-line-edit-spinner').hide();
                $('.lnk-add-menu').show();
                $('.lnk-edit-line').show();
            });
        },

        setupReportDimensionFilter = function () {
            $(document).on('shown.bs.modal', '.col-dimension-popup', function () {
                ReportDimensionFilterSetMainCheckbox();
                $('.checkbox-classes, .checkbox-department, .checkbox-projects').on('change', function () {
                    ReportDimensionFilterSetMainCheckbox();
                });

                $('#CheckboxClasses, #CheckboxDepartments, #CheckboxProjects').on('change', function () {
                    var checkboxClass = $(this).data('checkboxclass');
                    var isChecked = $(this).is(':checked');
                    $('.' + checkboxClass).prop('checked', isChecked);
                });

                function ReportDimensionFilterSetMainCheckbox() {
                    let checkClasses = $('.checkbox-classes:checked').length === $('.checkbox-classes').length;
                    let checkDepts = $('.checkbox-department:checked').length === $('.checkbox-department').length;
                    let checkProjs = $('.checkbox-projects:checked').length === $('.checkbox-projects').length;
                    $('#CheckboxClasses').prop('checked', checkClasses);
                    $('#CheckboxDepartments').prop('checked', checkDepts);
                    $('#CheckboxProjects').prop('checked', checkProjs);
                }
            });
        },

        setupColumnAddEditSection = function () {
            //========================================================================================================================
            // BEGIN COLUMN ADD/EDIT SECTION
            //========================================================================================================================
            $(document).on('shown.bs.modal', '.column-popup', function () {

                // adjust date ranges based on budget/actual option selected for IS
                var reportType = $('#hdnReportType').val();
                if (reportType == "IncomeStatement") {
                    checkDateRanges();
                }

                //Hide loading image after form is shown
                var columnID = $("#ColumnID").val();
                var originalHeadingValues = {
                    heading1: $("#Heading1ColumnHeading1Type").val(),
                    heading2: $("#Heading2ColumnHeading2Type").val(),
                    heading1Variance: $("#Heading1ColumnVarianceType").val(),
                    heading2Variance: $("#Heading2ColumnVarianceType").val()
                };

                $(`a[data-column-id='${columnID}']`).show();
                $(`i[data-column-id='${columnID}']`).hide();
                $(".column-add-a").show();
                $("#column-add-image-loading").hide();

                $('#DataType').on('change', function () {

                    // Cache the jQuery selectors for better performance
                    const $columnHeadingType = $('.column-heading-type');
                    const $columnVarianceType = $('.column-variance-type');
                    const $dateRange = $('.date-range');
                    const $budget = $('.budget');
                    const $varianceColumn = $('.variance-column');
                    const $navfiltertab = $('#nav-filter-tab');
                    const selectedValue = $(this).val();

                    // Hide all elements initially
                    $columnHeadingType.hide();
                    $columnVarianceType.hide();
                    $dateRange.hide();
                    $navfiltertab.hide();

                    // add/remove Full Year from date ranges based on Budget selection in IS
                    if (reportType == "IncomeStatement") {
                        checkDateRanges();
                    }

                    // Show the appropriate elements based on the selected value
                    if (selectedValue === '0' || selectedValue === '1' || selectedValue == '4') {
                        $dateRange.show();
                        $columnHeadingType.show();
                        $navfiltertab.show();
                        $('#Heading1ColumnHeading1Type').trigger('change');
                        $('#Heading2ColumnHeading2Type').trigger('change');
                    } else {
                        $columnVarianceType.show();
                        $('#Heading1ColumnVarianceType').trigger('change');
                        $('#Heading2ColumnVarianceType').trigger('change');
                    }

                    // Toggle the elements based on the selected value
                    $budget.toggle(selectedValue === '1');
                    $varianceColumn.toggle(selectedValue === '2');
                }).trigger('change');
                $('#Heading1ColumnHeading1Type').on('change', function () {
                    var dataType = $('#DataType').val();
                    if (dataType === '0' || dataType === '1' || dataType === '4') {
                        if ($(this).val() === '2') {
                            $('.heading-1-custom').show();
                        } else {
                            $('.heading-1-custom').hide();
                        }
                    }
                    columnHeadingShowHide(originalHeadingValues, columnID);
                }).trigger('change');
                $('#Heading2ColumnHeading2Type').on('change', function () {
                    var dataType = $('#DataType').val();
                    if (dataType === '0' || dataType === '1' || dataType === '4') {
                        if ($(this).val() === '2') {
                            $('.heading-2-custom').show();
                        } else {
                            $('.heading-2-custom').hide();
                        }
                    }
                }).trigger('change');
                $('#Heading1ColumnVarianceType').on('change', function () {
                    var dataType = $('#DataType').val();
                    if (dataType === '2') {
                        if ($(this).val() === '10') {
                            $('.heading-1-custom').show();
                        } else {
                            $('.heading-1-custom').hide();
                        }
                    }
                }).trigger('change');
                $('#Heading2ColumnVarianceType').on('change', function () {
                    var dataType = $('#DataType').val();
                    if (dataType === '2') {
                        if ($(this).val() === '10') {
                            $('.heading-2-custom').show();
                        } else {
                            $('.heading-2-custom').hide();
                        }
                    }
                }).trigger('change');
                $('#CompareColumnIDA').on('change', function () {
                    var selectedValue = $(this).val();
                    // Enable all options in CompareColumnIDB first
                    $('#CompareColumnIDB option').prop('disabled', false);

                    if (selectedValue !== '') {
                        // Disable the selected option in CompareColumnIDB
                        $('#CompareColumnIDB option[value="' + selectedValue + '"]').prop('disabled', true);
                    }
                }).trigger('change');
                $('#CompareColumnIDB').on('change', function () {
                    var selectedValue = $(this).val();
                    // Enable all options in CompareColumnIDB first
                    $('#CompareColumnIDA option').prop('disabled', false);
                    if (selectedValue !== '') {
                        // Disable the selected option in CompareColumnIDB
                        $('#CompareColumnIDA option[value="' + selectedValue + '"]').prop('disabled', true);
                    }
                }).trigger('change');
                $('#nav-position-tab').on('shown.bs.tab', function (e) {
                    setColumnPositionActiveScroll();
                });
                $("#ColumnName").on("input paste cut change keyup", function () {
                    updateColumnPositionColumnName();
                });

                $("#column-position-sortable").sortable(
                    {
                        axis: "x",
                        containment: "parent",
                    });

            });
        },

        checkDateRanges = function () {
            var dataType = $("#DataType").val();
            var thisFYEnd = $("#thisFYEnd").val();
            var lastYTDEnd = $("#lastYTDEnd").val();
            var lastFYEnd = $("#lastFYEnd").val();
            var lastQLYEnd = $("#lastQLYEnd").val();
            var lastMLYEnd = $("#lastMLYEnd").val();
            var fullYearOption = $("<option></option>").attr("value", "26").text("Full Fiscal Year (" + thisFYEnd + ")");
            var lastYTDOption = $("<option></option>").attr("value", "11").text("Last Year-to-Date (" + lastYTDEnd + ")");
            var lastFYOption = $("<option></option>").attr("value", "12").text("Last Full Year (" + lastFYEnd + ")");
            var lastQLYOption = $("<option></option>").attr("value", "13").text("Same Quarter, Last Year (" + lastQLYEnd + ")");
            var lastMLYOption = $("<option></option>").attr("value", "14").text("Same Month, Last Year (" + lastMLYEnd + ")");
            // if Budget selected, add Full year option, remove last year options
            if (dataType == '1') {
                removeVariableDateRangeOptions();
                $("#DateRange").find("option:eq(1)").before(fullYearOption);
                selectColDateRange();
            } else {
                removeVariableDateRangeOptions();
                // add in last year options
                $("#DateRange").append(lastYTDOption);
                $("#DateRange").append(lastFYOption);
                $("#DateRange").append(lastQLYOption);
                $("#DateRange").append(lastMLYOption);
                selectColDateRange();
            }
        },

        removeVariableDateRangeOptions = function () {
            $("#DateRange option[value='11']").remove();
            $("#DateRange option[value='12']").remove();
            $("#DateRange option[value='13']").remove();
            $("#DateRange option[value='14']").remove();
            $("#DateRange option[value='26']").remove();
        },

        selectColDateRange = function () {
            var colDateRange = $("#hdnDateRange").val();
            var dateRangeDropdown = $("#DateRange");
            if (dateRangeDropdown.find("option[value='" + colDateRange + "']").length > 0) {
                dateRangeDropdown.val(colDateRange);
            } else {
                dateRangeDropdown.val(dateRangeDropdown.find("option:first").val());
            }
        },

        columnHeadingShowHide = function (originalValues, columnId) {
            var currentHeadingValues = {
                heading1: $("#Heading1ColumnHeading1Type").val(),
                heading2: $("#Heading2ColumnHeading2Type").val(),
                heading1Variance: $("#Heading1ColumnVarianceType").val(),
                heading2Variance: $("#Heading2ColumnVarianceType").val()
            };
            if (
                originalValues.heading1 !== currentHeadingValues.heading1 ||
                originalValues.heading2 !== currentHeadingValues.heading2 ||
                originalValues.heading1Variance !== currentHeadingValues.heading1Variance ||
                originalValues.heading2Variance !== currentHeadingValues.heading2Variance
            ) {
                var $pElement = $(`.column-position-item[data-column-id='${columnId}'] .position-column-heading`);
                $pElement.text('');
            }
        },


        setColumnPositionActiveScroll = function () {
            var columnId = $("#ColumnID").val();
            var trg = document.querySelector(`[data-column-id='${columnId}]`);
            if (trg) trg.scrollIntoView({ behavior: "smooth", block: "center", inline: "center" });
        },


        updateColumnPositionColumnName = function () {
            var columnName = $("#ColumnName").val();
            let colID = document.getElementById('modalColumnEdit').dataset.columnId;
            $(`li[data-column-id='${colID}'] h6.position-column-name`).text(columnName);
        },


        columnsPosition = function () {
            let cols = [];
            $("#column-position-sortable li").each(function () {
                cols.push(this.dataset.columnId);
            });
            return cols;
        },


        isColumnValidToSave = function () {
            const errorMessages = {
                '#ColumnName': 'Column name is required',
                '#BudgetID': 'Budget is required',
                '#CompareColumnIDA': 'Please select an option',
                '#CompareColumnIDB': 'Please select an option',
                '#Heading1Custom': 'Custom Heading text is required',
                '#Heading2Custom': 'Custom Heading text is required',
            };

            $('.required-label').remove();

            let isValid = true;
            let isContentTabValid = true;
            let isHeadingsTabValid = true;

            // Validation for ColumnName
            if ($("#ColumnName").val().trim() === "") {
                showRequiredLabel("#ColumnName", errorMessages['#ColumnName']);
                isValid = false;
            }

            // Validation for DataType = 1
            if ($('#DataType').val() === '1') {
                if ($('#BudgetID').val().trim() === '') {
                    showRequiredLabel("#BudgetID", errorMessages['#BudgetID']);
                    isValid = false;
                    isContentTabValid = false;
                }
            }

            // Validation for DataType = 2
            if ($('#DataType').val() === '2') {
                if ($('#CompareColumnIDA').val().trim() === '') {
                    showRequiredLabel("#CompareColumnIDA", errorMessages['#CompareColumnIDA']);
                    isValid = false;
                    isContentTabValid = false;
                }
                if ($('#CompareColumnIDB').val().trim() === '') {
                    showRequiredLabel("#CompareColumnIDB", errorMessages['#CompareColumnIDB']);
                    isValid = false;
                    isContentTabValid = false;
                }
            }

            // Validation for DataType = 0 or 1 or 4
            if ($('#DataType').val() === '0' || $('#DataType').val() === '1' || $('#DataType').val() === '4') {
                if ($('#Heading1ColumnHeading1Type').val() === '2' && $('#Heading1Custom').val().trim() === '') {
                    showRequiredLabel("#Heading1Custom", errorMessages['#Heading1Custom']);
                    isValid = false;
                    isHeadingsTabValid = false;
                }
                if ($('#Heading2ColumnHeading2Type').val() === '2' && $('#Heading2Custom').val().trim() === '') {
                    showRequiredLabel("#Heading2Custom", errorMessages['#Heading2Custom']);
                    isValid = false;
                    isHeadingsTabValid = false;
                }
            }

            // Validation for DataType = 2
            if ($('#DataType').val() === '2') {
                if ($('#Heading1ColumnVarianceType').val() === '10' && $('#Heading1Custom').val().trim() === '') {
                    showRequiredLabel("#Heading1Custom", errorMessages['#Heading1Custom']);
                    isHeadingsTabValid = false;
                    isValid = false;
                }
                if ($('#Heading2ColumnVarianceType').val() === '10' && $('#Heading2Custom').val().trim() === '') {
                    showRequiredLabel("#Heading2Custom", errorMessages['#Heading2Custom']);
                    isHeadingsTabValid = false;
                    isValid = false;
                }
            }

            if (!isContentTabValid) {
                $("#nav-content-tab").prepend('<i class="fa fa-exclamation-triangle text-danger mr4 required-label"></i>');
            }

            if (!isHeadingsTabValid) {
                $("#nav-headings-tab").prepend('<i class="fa fa-exclamation-triangle text-danger mr4 required-label"></i>');
            }
            return isValid;
        },


        showAddColumnPopup = function () {
            _$wrapper.on('click', '.column-add-single', function () {
                _report_id = _$wrapper.find('#hdnReportID').val();

                $(".column-add-a").hide();
                $("#column-add-image-loading").show();

                if (!_popup_open) {
                    _popup_open = true;

                    delta.ajax.get(
                        '/Report/ColumnAdd?reportID=' + _report_id,
                        function (html) {
                            delta.popup.open({
                                type: 'generic',
                                title: 'Add Column',
                                content: html,
                                cssClass: 'column-popup',
                                afterOpen: function () {
                                    _popup_open = false;
                                    $(".column-add-a").show();
                                    $("#column-add-image-loading").hide();
                                },
                                buttons: [
                                    {
                                        text: 'Cancel',
                                        callback: function ($popup)
                                        {
                                            $(".column-add-a").show();
                                            $("#column-add-image-loading").hide();

                                            delta.popup.close($popup);
                                        }
                                    },
                                    {
                                        text: 'Save',
                                        isPrimary: true,
                                        callback: function ($popup) {
                                            //Client side validation
                                            if (isColumnValidToSave() === false) {
                                                delta.popup.enableButtons($popup);

                                                return;
                                            }
                                            $('.modal-body', $popup).animate({ scrollTop: 0 }, "fast");
                                            $('.modal-footer button', $popup).first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');
                                            var formData = new FormData();

                                            // Get all the filters and add it to the formData
                                            var filters = $('input[name="filters"]:checked').map(function () {
                                                return {
                                                    FilterType: $(this).attr("data-filtertype"),
                                                    FilterID: $(this).attr("data-filterid")
                                                };
                                            }).get();
                                            filters.forEach(function (filter, index) {
                                                formData.append(`Filters[${index}].FilterType`, filter.FilterType);
                                                formData.append(`Filters[${index}].FilterID`, filter.FilterID);
                                            });


                                            $popup.find('.modal-body').find('input:not([name="filters"]), select, textbox').each(function () {
                                                var $elem = $(this);
                                                formData.append($elem.attr('name'), $elem.val());
                                            });

                                            formData.append('reportID', parseInt(_$wrapper.find('#hdnReportID').val()));
                                            formData.append("columnIDPosition", JSON.stringify(columnsPosition()));

                                            delta.ajax.postFormData('/Report/ColumnSave',
                                                formData,
                                                function (result) {
                                                    if (result.ok) {
                                                        location.reload();
                                                    } else {
                                                        $('.modal-footer .fa-spinner', $popup).remove();
                                                        if (result.columnNameExists === true) {
                                                            showRequiredLabel("#ColumnName", 'Column name already exists');
                                                        }
                                                        delta.popup.enableButtons($popup);
                                                    }
                                                }
                                            );

                                            return false;
                                        }
                                    }
                                ],

                            });
                        }
                    );
                }
            });
        },


        showEditColumnPopup = function () {
            _$wrapper.on('click', '.column-edit', function () {
                if (!_popup_open) {
                    _popup_open = true;

                    let colId = this.dataset.columnId;

                    $(`a[data-column-id='${colId}']`).hide();
                    $(`i[data-column-id='${colId}']`).show();

                    delta.ajax.get(`/Report/ColumnEdit?reportID=${_report_id}&columnID=${colId}`,
                        function (html) {
                            delta.popup.open({
                                type: 'generic',
                                title: 'Column Edit',
                                content: html,
                                cssClass: 'column-popup',
                                afterOpen: function () {
                                    _popup_open = false;
                                    let reportType = $('#hdnReportType').val();

                                    // Handle special report types
                                    if (reportType === "NetAssetRollForward") {
                                        // For NARF, disable most tabs and only allow heading changes
                                        $('#nav-content-tab').addClass('disabled');
                                        $('#nav-filter-tab').addClass('disabled');
                                        $('#nav-position-tab').addClass('disabled');

                                        // Hide the Delete button for NARF columns
                                        $('.modal-footer button:contains("Delete")').hide();

                                        // Set Headings tab as active
                                        $('#nav-content').removeClass('show active');
                                        $('#nav-headings').addClass('show active');
                                        $('#nav-headings-tab').addClass('active');
                                    }
                                    else if (reportType === "FunctionalExpense") {
                                        // For FunctionalExpense, make sure the Content tab is disabled and set Headings as active
                                        $('#nav-content-tab').addClass('disabled');

                                        // Ensure Content tab is not active and Headings tab is active
                                        $('#nav-content').removeClass('show active');
                                        $('#nav-headings').addClass('show active');
                                        $('#nav-headings-tab').addClass('active');
                                    }
                                },
                                buttons: [
                                    {
                                        text: 'Cancel',
                                        callback: function ($popup) {
                                            $(`a[data-column-id='${colId}']`).show();
                                            $(`i[data-column-id='${colId}']`).hide();
                                            delta.popup.close($popup);
                                        }
                                    },
                                    {
                                        text: 'Save Changes',
                                        isPrimary: true,
                                        callback: function ($popup) {
                                            //Client side validation
                                            if (isColumnValidToSave() === false) {
                                                delta.popup.enableButtons($popup);
                                                return
                                            }

                                            $('.modal-body', $popup).animate({ scrollTop: 0 }, "fast");
                                            $('.modal-footer button', $popup).first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');

                                            var formData = new FormData();

                                            // Get all the filters and add it to the formData
                                            var filters = $('input[name="filters"]:checked').map(function () {
                                                return {
                                                    FilterType: $(this).attr("data-filtertype"),
                                                    FilterID: $(this).attr("data-filterid")
                                                };
                                            }).get();
                                            filters.forEach(function (filter, index) {
                                                formData.append(`Filters[${index}].FilterType`, filter.FilterType);
                                                formData.append(`Filters[${index}].FilterID`, filter.FilterID);
                                            });

                                            $popup.find('.modal-body').find('input:not([name="filters"]), select').each(function () {
                                                var $elem = $(this);
                                                var name = $elem.attr('name');
                                                var value = $elem.is(':checkbox') ? $elem.is(':checked') : $elem.val();
                                                formData.append(name, value);
                                            });

                                            formData.append('reportID', parseInt(_$wrapper.find('#hdnReportID').val()));
                                            formData.append('columnID', parseInt(_$wrapper.find('#columnID').val()))
                                            formData.append("columnIDPosition", JSON.stringify(columnsPosition()));

                                            // Source hidden for RF reports, FunctionalExpense, or NARF
                                            var hdnReportType = $popup.find('#hdnReportType').val();
                                            if (hdnReportType == "RollingForecast" || hdnReportType == "FunctionalExpense" || hdnReportType == "NetAssetRollForward") {
                                                var hdnDataType = $popup.find('#hdnDataType').val();
                                                if (hdnDataType) {
                                                    formData.set("DataType", hdnDataType);
                                                }
                                            }

                                            delta.ajax.postFormData('/Report/ColumnSave',
                                                formData,
                                                function (result) {
                                                    if (result.ok) {
                                                        location.reload();
                                                    } else {
                                                        $('.modal-footer .fa-spinner', $popup).remove();
                                                        showRequiredLabel("#ColumnName", result.msg);
                                                        delta.popup.enableButtons($popup);
                                                    }
                                                }
                                            );
                                            return false;
                                        }
                                    },
                                    {
                                        text: 'Delete',
                                        leftAlign: true,
                                        callback: function ($popup) {
                                            // For NARF columns, we don't allow deletion
                                            var hdnReportType = $popup.find('#hdnReportType').val();
                                            if (hdnReportType === "NetAssetRollForward") {
                                                return false;
                                            }

                                            delta.popup.open({
                                                type: 'confirm',
                                                title: 'Delete column ',
                                                content: 'Are you sure you want to delete this column?',
                                                cssClass: 'col-delete-popup',
                                                okButtonText: 'Yes, Delete',
                                                afterOpen: function ($popup) {
                                                    let mainPop = $('.column-popup');
                                                    mainPop.css('opacity', '0.6');
                                                    $popup.find('.modal-footer .btn-primary').removeClass('btn-primary').addClass('btn-danger');
                                                },
                                                okCallback: function ($popup2) {
                                                    $('.modal-footer button', $popup2).first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');
                                                    delta.ajax.postFormData(`/Report/ColumnDelete?reportID=${_report_id}&columnID=${colId}`, new FormData(),
                                                        function (result) {
                                                            if (result.ok) {
                                                                location.reload();
                                                            } else {
                                                                $popup.find('.modal-body').html(result.popupHtml);
                                                                delta.popup.enableButtons($popup);
                                                            }
                                                        }
                                                    )

                                                    return false;
                                                },
                                                cancelCallback: function () {
                                                    let mainPop = $('.column-popup');
                                                    mainPop.css('opacity', '1');
                                                    delta.popup.enableButtons(mainPop);
                                                }
                                            })

                                            return false;
                                        }
                                    }
                                ]
                            });
                        }
                    );
                }
            });
        },
        

        showAddDimensionColumnsPopup = function () {
            _$wrapper.on('click', '.column-add-dimensions', function () {
                $(".column-add-a").hide();
                $("#column-add-image-loading").show();

                if (!_popup_open) {
                    _popup_open = true;

                    delta.ajax.get(`/Report/AddDimensionColumns`,
                        function (html) {
                            delta.popup.open({
                                title: 'Add Dimension Columns',
                                content: html,
                                cssClass: 'col-dimension-popup modal-full-height modal-dialog-centered',
                                afterOpen: function ($popup) {
                                    _popup_open = false;
                                    $(".column-add-a").show();
                                    $("#column-add-image-loading").hide();

                                    delta.reportDimensionColumns.init($popup);
                                },
                                buttons: [
                                    {
                                        text: 'Cancel',
                                        callback: function ($popup) {
                                            $(".column-add-a").show();
                                            $("#column-add-image-loading").hide();

                                            delta.popup.close($popup);
                                        }
                                    },
                                    {
                                        text: 'Save',
                                        isPrimary: true,
                                        callback: function ($popup) {
                                            $('.col-dimension-popup .modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');
                                            
                                            if (delta.reportDimensionColumns.validate()) {
                                                var formData = new FormData();
                                                $popup.find('.modal-body').find('input:checked, select').each(function() {
                                                    formData.append($(this).attr('name'), $(this).val());
                                                });
                                                
                                                delta.ajax.postFormData('/Report/AddDimensionColumns',
                                                    formData,
                                                    function (result) {
                                                        location.reload();
                                                    }
                                                );
                                            } else {
                                                //remove the spinner
                                                $popup.find('.modal-footer').find('.fa-spinner').remove();

                                                //enable the buttons
                                                delta.popup.enableButtons($popup);
                                            }

                                            return false;
                                        }
                                    }
                                ]
                            });
                        }
                    );
                }
            });
        },

        
        showRequiredLabel = function (elementID, errorMessage) {
            $(elementID).after(`<label class="required-label text-danger">${errorMessage}</label>`);
        },

        //
        // =======================  Net Asset Roll Forward functions ========================================
        //
        showEditValuePopup = function () {
            _$wrapper.on('click', '.narf-edit', function () {
                var reportID = _$wrapper.find('#hdnReportID').val();
                var $row = $(this).closest('tr');
                var lineID = $row.data('line-id');
                var lineLabel = $row.find('.report-label').find('div').text();
                var isNotesOnly = this.dataset.lineShowNotes.toLowerCase() == 'true';

                // Hide only the clicked row's edit buttons
                $row.find(".narf-edit").toggle().next().toggle();

                if (!_popup_open) {
                    _popup_open = true;

                    delta.ajax.get(`/report/narf/editline?reportID=${reportID}&lineID=${lineID}`,
                        function (html) {
                            delta.popup.open({
                                type: 'generic',
                                title: isNotesOnly ? `Edit Notes: ${lineLabel}` : `Edit Line Item: ${lineLabel}`,
                                content: html,
                                cssClass: 'line-edit-popup',
                                afterOpen: function ($popup) { _popup_open = false; },
                                buttons: [
                                    {
                                        text: 'Cancel',
                                        callback: function ($popup) {
                                            $row.find(".narf-edit").toggle().next().toggle();
                                            delta.popup.close($popup);
                                            $popup.remove();
                                        }
                                    },
                                    {
                                        text: 'Save',
                                        isPrimary: true,
                                        callback: function ($popup) {
                                            let dataObj = { LineID: lineID, ReportID: reportID, IsPopulated: true }; 
                                            if (isNotesOnly) {
                                                // Save only Notes field
                                                dataObj.Notes = $('#notes').val();
                                            } else {
                                                // Save all fields (FLATTEN the keys)
                                                $popup.find('input, textarea').each(function () {
                                                    var $elem = $(this);
                                                    var query = $elem.attr('name'); 
                                                    if (query) {
                                                        var name = query.replace(/^Data\./, ''); // Remove "Data." prefix
                                                        if (name) 
                                                            dataObj[name] = $elem.val();
                                                    }
                                                });
                                            }

                                            delta.ajax.post(`/report/narf/editline?reportID=${reportID}&lineID=${lineID}`, dataObj,
                                                function (result) {
                                                    if (result.ok) {
                                                        window.location.reload();
                                                        delta.popup.close($popup);
                                                    } else {
                                                        delta.popup.enableButtons($popup);
                                                    }
                                                }
                                            );

                                            return false;
                                        }
                                    }
                                ],
                            });
                        }
                    );
                }
            });
        };


        showRestrictionsPopup = function () {
            _$wrapper.on('click', '#showRestrictions', function () { // Now only triggers for this button
                _report_id = _$wrapper.find('#hdnReportID').val();

                $(".column-add-a").hide();
                $("#column-add-image-loading").show();

                if (!_popup_open) {
                    _popup_open = true;

                    delta.ajax.get(`/report/narf/config?reportID=${_report_id}`,
                        function (html) {
                            delta.popup.open({
                                type: 'generic',
                                title: 'Restrictions and Receivable',
                                content: html,
                                cssClass: 'column-popup',
                                afterOpen: function () {
                                    _popup_open = false;
                                },
                                buttons: [
                                    {
                                        text: 'Cancel',
                                        callback: function ($popup) {
                                            $(".column-add-a").show();
                                            $("#column-add-image-loading").hide();
                                            delta.popup.close($popup);
                                        }
                                    },
                                    {
                                        text: 'Save',
                                        isPrimary: true,
                                        callback: function ($popup) {
                                            var showRestrictionsColumns = $('#showRestrictionsCheckbox').is(':checked') ? true : false;
                                            var showNotesColumn = $('#showNotesCheckbox').is(':checked') ? true : false;

                                            var formData = new FormData();

                                            formData.append('reportID', _report_id);
                                            formData.append('showReceivableColumns', showRestrictionsColumns);
                                            formData.append('showNotesColumn', showNotesColumn);

                                            delta.ajax.postFormData(`/report/narf/config?reportID=${_report_id}`,
                                                formData,
                                                function (result) {
                                                    if (result.ok) {
                                                        window.location.reload();
                                                        delta.popup.close($popup);
                                                    } else {
                                                        $('#autoPopup_1 .modal-footer .fa-spinner').remove();
                                                        delta.popup.enableButtons($popup);
                                                    }
                                                }
                                            );

                                            return false;
                                        }
                                    }
                                ],
                            });
                        }
                    );
                }
            });
        };




        //
        // =======================  Rolling Forecast functions ========================================
        //
        setupForecastPopup = function () {
            _$wrapper.on('click', '.forecast-edit', function () {

                var $a = $(this);
                var $icon = $a.find('.forecast-icon');
                var $spinner = $a.find('.forecast-spinner');
                $spinner.show();
                $icon.hide();

                var lineID = $(this).closest('tr').attr('data-line-id');
                if (!_popup_open) {
                    _popup_open = true;

                    delta.ajax.get(`/Report/ForecastEdit?lineID=${lineID}`,
                        function (html) {
                            delta.popup.open({
                                title: 'Forecast Amounts',
                                type: 'confirm',
                                okButtonText: 'Save',
                                content: html,
                                afterOpen: function () {
                                    _popup_open = false;
                                    $icon.show();
                                    $spinner.hide();
                                },
                                okCallback: function ($popup) {

                                    $popup.find('.modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');

                                    var reportID = $popup.find('#Report_ID').val();
                                    var lineID = $popup.find('#ReportLine_LineID').val();
                                    var forecastEntryInputs = $popup.find('input.forecast-entry:not([readonly]):not(:disabled)');

                                    var formData = new FormData();

                                    forecastEntryInputs.each(function (index) {
                                        var id = $(this).data('forecast-id');
                                        var forecastMonth = $(this).data('forecast-month');
                                        var amount = $(this).val() != "" ? $(this).val() : 0;

                                        formData.append('forecasts[' + index + '][ID]', id);
                                        formData.append('forecasts[' + index + '][ReportID]', reportID);
                                        formData.append('forecasts[' + index + '][LineID]', lineID);
                                        formData.append('forecasts[' + index + '][ForecastMonth]', forecastMonth);
                                        formData.append('forecasts[' + index + '][Amount]', amount);
                                    });

                                    delta.ajax.postFormData('/Report/ForecastSave',
                                        formData,
                                        function (result) {
                                            location.reload();
                                        }
                                    );

                                    return false;

                                }
                            });
                        }
                    );
                }

            })

        },

        setupRollingForecastColumnSettings = function () {
            $('#btnRFColumnSettings').on('click', function () {

                if (!_popup_open) {
                    _popup_open = true;

                    delta.ajax.get('/Report/RollingForecastColumnSettings',
                        function (html) {
                            delta.popup.open({
                                title: 'Column Settings',
                                type: 'confirm',
                                okButtonText: 'Save',
                                content: html,
                                afterOpen: function ($popup) {
                                    _popup_open = false;
                                    setupColumnSettings($popup);
                                    
                                },
                                okCallback: function ($popup) {

                                    $popup.find('.modal-footer button').first().before('<i class="fa-regular fa-spinner fa-spin fs-3"></i>');

                                    var formData = new FormData();

                                    $popup.find('.modal-body').find('input, select').each(function () {
                                        var $elem = $(this);
                                        var name = $elem.attr('name');

                                
                                        // For checkboxes, set the value to true if checked, otherwise false
                                        var value = $elem.is(':checkbox, :radio') ? $elem.is(':checked') : $elem.val();

                                        formData.append(name, value);

                                    });

                                    delta.ajax.postFormData('/Report/RollingForecastColumnSettings',
                                        formData,
                                        function (result) {
                                            if (result.ok) {
                                                location.reload();
                                            } else {
                                                $popup.find('.modal-body').html(result.html);
                                                $popup.find('.modal-footer .fa-spinner').remove();
                                                delta.popup.enableButtons($popup);
                                                setupColumnSettings($popup);
                                            }
                                        }
                                    );

                                    return false;

                                }
                            });
                        }
                    );
                }

            })

        },

        setupColumnSettings = function ($popup) {

            setupColumnSettingsToggle($popup);

            var $chkAnnualBudget = $popup.find('#HasAnnualBudgetColumn');
            var $chkVariance = $popup.find('#HasVarianceColumn');

            $chkAnnualBudget.add($chkVariance).on('click', function () {
                setupColumnSettingsToggle($popup);
            });
        },


        setupColumnSettingsToggle = function ($popup) {
            var budgetChecked = $popup.find('#HasAnnualBudgetColumn').prop('checked');
            var $annualBudgetDropdown = $popup.find('#AnnualBudgetID');
            var $chkVariance = $popup.find('#HasVarianceColumn');
            var varianceChecked = $chkVariance.prop('checked');
            var $varianceDropdown = $popup.find('#VarianceType');


            // set variance check option based on total and budget checked
            if (!budgetChecked) {
                $chkVariance.prop('checked', false);
                varianceChecked = false;
            }
            
            // set enable/disable options
            $annualBudgetDropdown.prop('disabled', !budgetChecked);
            $varianceDropdown.prop('disabled', !varianceChecked);
            $chkVariance.prop('disabled', !budgetChecked);

        }

    //
    // ========================================================================================
    //

    dummy = function () { };

    $(document).ready(init);

}();